import {useCallback} from 'react';

import {useCommonEventHook} from 'src/hooks/use-common-event-hook';
import {deleteSsoDraft} from 'src/openapi/admin/apis/SsoDraftsApi';
import {useAppDispatch} from 'src/store/hooks';

type Props = {
    draftId: number,
    onSuccess: () => void,
    onFail: (error: string) => void,
};

export const useDeleteSsoDraft = ({draftId, onSuccess, onFail}: Props) => {
    const dispatch = useAppDispatch();
    const eventAction = useCallback(() => dispatch(deleteSsoDraft({draftId})), [dispatch, draftId]);

    return useCommonEventHook({eventAction, onSuccess, onFail});
};
